export const CACHE_IDS = {
	VEC3_DIR:		0,
	VEC3_DIFF:		1,
	VEC3_DIFF1:		2,
	VEC3_DIFF2:		3,
	VEC3_POINT1:	4,
	VEC3_POINT2:	5,
	VEC3_POINT3:	6,
	VEC3_SIDE1:		7,
	VEC3_SIDE2:		8,
	VEC3_SIDE3:		9,
	VEC3_NORMAL:	10,
};

export default class MemoryCacher
{
	constructor()
	{
		this.memory = [];
	}

	getVector3(eId)
	{
		let object = this.memory[eId];
		if(!object)
		{
			object = BABYLON.Vector3.Zero();
			this.memory[eId] = object;
		}

		return object;
	}
}